<template>
  <v-navigation-drawer
    v-model="opened"
    height="100vh"
    width="350"
    location="right"
    floating
    fixed
    temporary
    hide-overlay
    class="drawer-info">

    <div class="header-drawer">
      <span>Detalles</span>
        <v-icon class="mr-2"
        @click="opened = false">
          mdi-close
        </v-icon>
    </div>

    <v-expansion-panels v-model="panelOpen" >

      <v-expansion-panel>
        <v-expansion-panel-title>
          <span class="title-section-drawer">
            Generales
          </span>
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <div class="container-element-drawer">
            <span class="title-elemet-drawer">Creado</span>
            <span class="element-drawer">{{ formatTimestamp(business.created_at) }}</span>
          </div>
          <div class="container-element-drawer">
            <span class="title-elemet-drawer">Nombre del negocio</span>
            <span class="element-drawer">{{ business.name }}</span>
          </div>
          <div class="container-element-drawer">
            <span class="title-elemet-drawer">Clasificación</span>
            <span class="element-drawer">{{ business.category }}</span>
          </div>
          <div class="container-element-drawer">
            <span class="title-elemet-drawer">Perfil público</span>
            <span class="element-drawer">{{ business.url }}</span>
          </div>
        </v-expansion-panel-text>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-title class="justify-start">
          <span class="title-section-drawer">
            Descripción
          </span>
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <div class="container-element-drawer">
            <span class="element-drawer">{{ business.description }}</span>
          </div>
        </v-expansion-panel-text>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-title class="justify-start">
          <span class="title-section-drawer">
            Domicilio
          </span>
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <div class="container-element-drawer">
            <span class="title-elemet-drawer">Dirección</span>
            <span class="element-drawer">{{ business.address }}</span>
          </div>
          <div class="container-element-drawer">
            <span class="title-elemet-drawer">Código Postal</span>
            <span class="element-drawer">{{ business.postal_code }}</span>
          </div>
          <div class="container-element-drawer">
            <span class="title-elemet-drawer">Ciudad</span>
            <span class="element-drawer">{{ business.city }}</span>
          </div>
          <div class="container-element-drawer">
            <span class="title-elemet-drawer">Estado</span>
            <span class="element-drawer">{{ business.state }}</span>
          </div>
          <div class="container-element-drawer">
            <span class="title-elemet-drawer">País</span>
            <span class="element-drawer">{{ business.country }}</span>
          </div>
        </v-expansion-panel-text>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-title class="justify-start">
          <span class="title-section-drawer">
            Facturación
          </span>
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <div class="container-element-drawer">
            <span class="title-elemet-drawer">Razón social</span>
            <span class="element-drawer">{{ business.legal_entity }}</span>
          </div>
          <div class="container-element-drawer">
            <span class="title-elemet-drawer">RFC</span>
            <span class="element-drawer">{{ business.rfc }}</span>
          </div>
          <div class="container-element-drawer">
            <span class="title-elemet-drawer">Uso de CFDI</span>
            <span class="element-drawer">{{ business.invoice_usage }}</span>
          </div>
          <div class="container-element-drawer">
            <span class="title-elemet-drawer">Domicilio fiscal</span>
            <span class="element-drawer">{{ business.tax_residence }}</span>
          </div>
          <div class="container-element-drawer">
            <span class="title-elemet-drawer">Email de facturación</span>
            <span class="element-drawer">{{ business.invoice_email }}</span>
          </div>

        </v-expansion-panel-text>
      </v-expansion-panel>

    </v-expansion-panels>

    <div class="container-bottom-drawer">
      <v-btn
        color="#FF5700"
        class="btn-outline-drawer"
        variant="outlined"
        rounded="xl"
        @click="openEdit">
        Editar
      </v-btn>
    </div>

  </v-navigation-drawer>
</template>

<script>
import dateTransform from '@/utils/dateTransform'
export default {
  name: 'CommerciaVueBusinessDrawer',
  emits: ['openEditBusiness'],
  data () {
    return {
      opened: false,
      panelOpen: [0],
      business: {
        category: null,
        active: null,
        address: null,
        city: null,
        country: null,
        created_at: null,
        description: null,
        invoice_email: null,
        invoice_usage: null,
        legal_entity: null,
        name: null,
        postal_code: null,
        rfc: null,
        state: null,
        tax_residence: null,
        updated_at: null,
        url: null,
        _id: null,
        business_key: null
      }
    }
  },

  methods: {
    show (business) {
      this.opened = true
      this.business = structuredClone(business)
      this.panelOpen = [0]
    },
    openEdit () {
      this.opened = false
      this.$emit('openEditBusiness', this.business)
    },
    formatTimestamp (timestamp) {
      return dateTransform.timestampToFormat(timestamp)
    }
  }
}
</script>

<style scoped>
  @import '@/assets/styles/drawers.css';
</style>
